<ng-container *ngIf="_item.type === 'container'">
  <atlas-nav-item-container [indentation]="indentation" [item]="_item.container">
    <atlas-bc-nav-item
      *ngFor="let subItem of _item.container.sideNavigationItems"
      [item]="subItem"
      [indentation]="indentation + 1"
    ></atlas-bc-nav-item>
  </atlas-nav-item-container>
</ng-container>

<ng-container *ngIf="_item.type === 'section'">
  <atlas-nav-item-section [indentation]="indentation" [item]="_item.section">
    <atlas-bc-nav-item
      *ngFor="let subItem of _item.section.sideNavigationItems"
      [item]="subItem"
      [indentation]="indentation + 1"
    ></atlas-bc-nav-item>
  </atlas-nav-item-section>
</ng-container>

<ng-container *ngIf="_item.type === 'link'">
  <atlas-nav-item [indentation]="indentation" [item]="_item.link"></atlas-nav-item>
</ng-container>
